import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MODAL_TYPE_CLIENT_CREATE_BOARD } from '../../../../actions/ModalActions';
import { propFunc } from '../../../../helpers/custom-prop-types';
import Modal from '../../../Ui/Modal';
import FormCreateBoard from '../Form/FormCreateBoard';
const ModalCreateBoard = (props) => {
    const { handleSubmit } = props;
    return (_jsx(Modal, Object.assign({ modalType: MODAL_TYPE_CLIENT_CREATE_BOARD }, { children: _jsx(FormCreateBoard, { onSubmit: handleSubmit }) })));
};
ModalCreateBoard.propTypes = {
    handleSubmit: propFunc().isRequired,
};
export default ModalCreateBoard;
